import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { ReactNode, useMemo } from 'react'
import { ControlSize } from 'types'
import { Container, Dnd } from './style'

type Props = {
    backgroundColor?: string
    children?: ReactNode
    className?: string
    color?: string
    disabled?: boolean
    dndId?: string
    duration?: number
    scrubbable?: boolean
    size?: ControlSize
    time?: number
    onScrub?: (time: number) => void
    onScrubEnd?: (time: number) => void
    onScrubStart?: (time: number) => void
}

export const PlayheadWithoutContext = ({
    backgroundColor,
    children,
    color = '#fff',
    className,
    disabled = false,
    dndId,
    duration = 0,
    scrubbable = false,
    size = 'medium',
    time = 0,
    onScrub,
    onScrubEnd,
    onScrubStart,
}: Props) => {
    const progress = useMemo(() => Math.max(0, Math.min(1, time / duration)), [duration, time])

    const onDrag = (value: number) => {
        onScrub?.(value * duration)
    }

    const onDragEnd = (value: number) => {
        onScrubEnd?.(value * duration)
    }

    const onDragStart = (value: number) => {
        onScrubStart?.(value * duration)
    }

    return (
        <Container backgroundColor={backgroundColor} className={className} disabled={disabled}>
            {children}
            <Dnd
                color={color}
                disabled={disabled || !scrubbable}
                dndId={dndId}
                size={size}
                value={progress}
                onDrag={onDrag}
                onDragEnd={onDragEnd}
                onDragStart={onDragStart}
            />
        </Container>
    )
}

const Playhead = (props: Props) => {
    const pointerSensor = useSensor(PointerSensor)
    const sensors = useSensors(pointerSensor)

    return (
        <DndContext sensors={sensors}>
            <PlayheadWithoutContext {...props} />
        </DndContext>
    )
}

export default Playhead
